import { useMemo } from 'react';
import { useProposalProject } from './useProposalProject';
/**
 * Returns a Map<userId, displayName> built from the project's member list.
 * Used by activity feeds to resolve user IDs to human-readable names.
 */ export function useUserLookup(projectId) {
    const { data } = useProposalProject(projectId ?? '');
    return useMemo(()=>{
        const map = new Map();
        if (!data?.members) return map;
        for (const m of data.members){
            if (m.userId && m.name) {
                map.set(m.userId, m.name);
            } else if (m.userId && m.email) {
                map.set(m.userId, m.email.split('@')[0]);
            }
        }
        return map;
    }, [
        data?.members
    ]);
}
